export function ADD_VOUCHER(body = {}) {
    return {
        type: "ADD_VOUCHER",
        body
    };
};

export function UPDATE_VOUCHER(body = {}){
    return {
        type: "UPDATE_VOUCHER",
        body
    }
}

export function REMOVE_VOUCHER(body = {}){
    return {
        type: "REMOVE_VOUCHER",
        body
    }
}

export function CHECK_VOUCHER(body = {}){
    return {
        type: "CHECK_VOUCHER",
        body
    }
}

export function GET_VOUCHERS(body = {}){
    return {
        type: "GET_VOUCHERS",
        body
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/voucher.js